import { render, staticRenderFns } from "./TestCallDialog.vue?vue&type=template&id=31dbcc64&scoped=true"
import script from "./TestCallDialog.vue?vue&type=script&lang=js"
export * from "./TestCallDialog.vue?vue&type=script&lang=js"
import style0 from "./TestCallDialog.vue?vue&type=style&index=0&id=31dbcc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbcc64",
  null
  
)

export default component.exports